module.exports = __webpack_public_path__ + "images/icon/loading-eae8fc3b.svg";